import React, {
  useEffect, useState, useMemo, useCallback,
} from 'react';
import './ImageUpload.less';
import {
  Upload, Typography, Form, Input, Image,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import firebase from 'firebase';
import { AuthContext } from 'util/Auth';
import { v4 as uuidv4 } from 'uuid';
import { productProperties } from 'config/language';

const { Text } = Typography;
const { Dragger } = Upload;

const PLACEHOLDER_IMAGE = 'data:image/png;base64,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';

let storageRef;

// TODO: Refactor the below component and the nested ImageUpload
// component within the Artwork component so that there is no code duplication
const ImageUpload = ({
  fieldName, directoryPath, fileLabel, form, onChange, disabled, circleImage,
}) => {
  useEffect(() => {
    if (!storageRef) {
      storageRef = firebase.storage().ref();
    }
  }, []);

  const [imageUrl, setImageUrl] = useState(form?.getFieldValue(fieldName));

  const onImageUrlChange = useCallback((newImageUrl) => {
    // Set field in form instance.
    form.setFieldsValue({
      [fieldName]: newImageUrl,
    });
    // Set field locally in component to render image.
    setImageUrl(newImageUrl);
    // Optionally notifiy parent component of change.
    if (onChange) {
      onChange(newImageUrl);
    }
  }, [form, fieldName, onChange, setImageUrl]);

  // TODO: Delete previous image if replacing.
  // TODO: Delete all images if leaving without saving.
  const handleUpload = useCallback(({
    file, onSuccess, onError, onProgress,
  }) => {
    const extension = file.name.substring(file.name.lastIndexOf('.'), file.name.length).toLowerCase();
    const newFilename = `${fileLabel}${extension}`;
    const uploadTask = storageRef.child(`${directoryPath}${newFilename}`).put(file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
      next: (snapshot) => onProgress({
        percent: (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
      }),
      error: (error) => {
        // TODO: Show error message below upload button.
        onError(error);
      },
      complete: () => {
        uploadTask.snapshot.ref.getDownloadURL()
          .then((newImageUrl) => {
            onSuccess();
            onImageUrlChange(newImageUrl);
          });
      },
    });
  }, [onImageUrlChange]);

  const uploadProps = useMemo({
    className: 'file-upload',
    maxCount: 1,
    customRequest: handleUpload,
    accept: 'image/png, image/jpeg',
    // TODO
    // max file size
    showUploadList: {
      showRemoveIcon: false,
      showPreviewIcon: false,
      showDownloadIcon: false,
    },
  }, [handleUpload]);

  return (
    <div className="upload-container">
      <Dragger {...uploadProps} disabled={disabled}>
        {imageUrl && (
        <Image
          preview={false}
          src={imageUrl || PLACEHOLDER_IMAGE}
          alt={fileLabel}
          fallback={PLACEHOLDER_IMAGE}
          className={circleImage ? 'circle-image' : null}
        />
        )}
        <div className="upload-message-container">
          {imageUrl ? (
            <Text className="replace-helper-text">Click here or drag a new image on to replace</Text>
          ) : (
            <>
              <UploadOutlined className="upload-icon-drag" />
              <Text>Click here or drag an image on to upload</Text>
            </>
          )}
        </div>
      </Dragger>

      {/* {imageUrl && (
        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />} disabled={uploading}>
            Replace Image
          </Button>
        </Upload>
        )} */}

      {/* Hidden field to store the URL as a form item. */}
      <Form.Item name={fieldName} style={{ display: 'none' }}>
        <Input />
      </Form.Item>
    </div>
  );
};

export default ImageUpload;
